import { Stack, Skeleton } from '@packages/shared';
import dynamic from 'next/dynamic';
import type { CustomerNrLoginFormProps } from './CustomerNrLoginForm';

export const DynamicCustomerNrLoginForm = dynamic<CustomerNrLoginFormProps>(
  () => import('./CustomerNrLoginForm'),
  {
    ssr: false,
    loading: () => (
      <Stack spacing={3} sx={{ py: 3, px: 4, width: '100%' }}>
        <Skeleton variant="rectangular" height={45} />
        <Skeleton variant="rectangular" height={45} />
        <Skeleton variant="rectangular" height={30} />
        <Skeleton sx={{ alignSelf: 'end' }} variant="rectangular" width={140} height={40} />
      </Stack>
    ),
  },
);
